var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_611_5200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3768 7.80896L15.5424 5.64334C16.4593 4.80763 17.6629 4.35735 18.9032 4.38606C20.1435 4.41477 21.325 4.92027 22.2023 5.79752C23.0795 6.67476 23.585 7.85629 23.6137 9.09657C23.6424 10.3368 23.1922 11.5405 22.3564 12.4574L19.2611 15.5418C18.815 15.9895 18.2849 16.3448 17.7012 16.5873C17.1175 16.8297 16.4916 16.9545 15.8596 16.9545C15.2275 16.9545 14.6017 16.8297 14.0179 16.5873C13.4342 16.3448 12.9041 15.9895 12.458 15.5418",
    stroke: "#06C15B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6234 20.1906L12.4578 22.3562C11.5409 23.192 10.3373 23.6422 9.09698 23.6135C7.8567 23.5848 6.67518 23.0793 5.79794 22.2021C4.92069 21.3248 4.41519 20.1433 4.38647 18.903C4.35776 17.6627 4.80804 16.4591 5.64375 15.5422L8.73906 12.4578C9.18516 12.01 9.71528 11.6547 10.299 11.4123C10.8827 11.1699 11.5086 11.0451 12.1406 11.0451C12.7727 11.0451 13.3985 11.1699 13.9823 11.4123C14.566 11.6547 15.0961 12.01 15.5422 12.4578",
    stroke: "#06C15B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_611_5200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.f730b7a6c1426baec574fb496b1b540d.svg";
export { ForwardRef as ReactComponent };